// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3UiZM","title":"ClientCherryInfo_title__hWX2g","itemText":"ClientCherryInfo_itemText__23_m1"};